/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { Layout, BackTop, Row, Col, Button, Tooltip } from "antd";
import { ArrowUpOutlined } from "@ant-design/icons";
import { IoLocationOutline } from "react-icons/io5";
import { FaFacebookF, FaFacebookMessenger } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const { Content } = Layout;

const LayoutFooter = () => {
  // -------------------------- VAR --------------------------
  const { t } = useTranslation("translation", { keyPrefix: "footer" });
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------

  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  const renderBody = () => {
    return (
      <Row justify="center" align="top" gutter={[48, 24]}>
        {renderCol01()}
        {renderCol02()}
        {renderCol03()}
        {renderCol04()}
      </Row>
    );
  };

  const renderCol01 = () => {
    return (
      <Col xs={24} sm={12} md={12} lg={6} xl={6}>
        <h5 className="footer-title">
          <IoLocationOutline className="footer-icon" />
          {t("addressVnTitle")}
        </h5>
        <p> {t("addressVnInfo")}</p>
        <h5 className="footer-title">
          <IoLocationOutline className="footer-icon" />
          {t("addressNzTitle")}
        </h5>
        <p>
          Suite 809, Level 8, 25 Restwell Street, Bankstown, 2200, Australia
        </p>
      </Col>
    );
  };

  const renderCol02 = () => {
    return (
      <Col xs={24} sm={12} md={12} lg={6} xl={6}>
        <h5 className="footer-title">{t("policy")}</h5>
        <ul className="menu">
          <li>
            <a
              title={t("privacy")}
              target="_blank"
              rel="noopener"
              href={"/policy.html"}
            >
              {t("privacy")}
            </a>
          </li>
          <li>
            <a
              title={t("userTerm")}
              target="_blank"
              rel="noopener"
              href={"/client-policy.html"}
            >
              {t("userTerm")}
            </a>
          </li>
          <li>
            <a
              title={t("partnerTerm")}
              target="_blank"
              rel="noopener"
              href={"/term.html"}
            >
              {t("partnerTerm")}
            </a>
          </li>
        </ul>
      </Col>
    );
  };

  const renderCol03 = () => {
    return (
      <Col xs={24} sm={12} md={12} lg={6} xl={6}>
        <h5 className="footer-title">Le Viet Group</h5>
        <Row justify="space-between" align="middle" gutter={[16, 16]}>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            {/* <img src={qrImage} alt="HALI Australia QR" /> */}
          </Col>
          <Col xs={14} sm={14} md={14} lg={14} xl={14}>
            <Row justify="space-between" align="middle" gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <a href={"/client-app"} target="_blank" alt="App Store">
                  {/* <img src={appStore} alt="App Store" /> */}
                </a>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <a href={"/client-app"} target="_blank" alt="Play Store">
                  {/* <img src={playStore} alt="Play Store" /> */}
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    );
  };

  const renderCol04 = () => {
    return (
      <Col xs={24} sm={12} md={12} lg={6} xl={6}>
        <h5 className="footer-title"> {t("connect")}</h5>
        <Row justify="space-between" align="middle" gutter={[16, 16]}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            style={{ textAlign: "center" }}
          >
            <Tooltip title="facebook">
              <Button
                type="link"
                href="#"
                target="_blank"
                icon={<FaFacebookF style={{ fontSize: 25, color: "#fff" }} />}
              />
            </Tooltip>
            <Tooltip title="messenger">
              <Button
                type="link"
                href="#"
                target="_blank"
                icon={
                  <FaFacebookMessenger
                    style={{ fontSize: 25, color: "#fff" }}
                  />
                }
              />
            </Tooltip>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <ul className="menu">
              <li>
                <a href="mailto:support@levietgroup.co.nz">
                  Email: support@levietgroup.co.nz
                </a>
              </li>
              <li>
                <a href="tel:+6494893988">Hotline: +64 9 489 3988</a>
              </li>
            </ul>
          </Col>
        </Row>
      </Col>
    );
  };

  const renderBottom = () => {
    return (
      <Row justify="space-between" align="middle" className="bottom">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          style={{ textAlign: "center" }}
        >
          Booking Beauty System ©2023. All rights reserved. Version v1.0.0
        </Col>
      </Row>
    );
  };

  const renderBackToTop = () => {
    return (
      <BackTop>
        <div
          style={{
            height: 40,
            width: 40,
            lineHeight: "40px",
            borderRadius: 4,
            backgroundColor: "#385898",
            textAlign: "center",
            color: "#fff",
            fontSize: 17,
          }}
        >
          <ArrowUpOutlined />
        </div>
      </BackTop>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <>
      <Layout.Footer>
        <Content className="content">
          {/* {renderBody()} */}
          {renderBottom()}
        </Content>
      </Layout.Footer>
      {renderBackToTop()}
    </>
  );
};

export default LayoutFooter;
